import { render, staticRenderFns } from "./LanguageCreate.vue?vue&type=template&id=8ed7168c&"
import script from "./LanguageCreate.vue?vue&type=script&lang=js&"
export * from "./LanguageCreate.vue?vue&type=script&lang=js&"
import style0 from "./LanguageCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports